// src/components/AuroraBackground.js
import React from 'react';
import './AuroraBackground.css';

const AuroraBackground = () => {
  return (
    <div className="aurora-background">
      <div className="aurora-shape aurora-shape-1"></div>
      <div className="aurora-shape aurora-shape-2"></div>
      <div className="aurora-shape aurora-shape-3"></div>
    </div>
  );
};

export default AuroraBackground;